<table class="table-auto border-collapse w-full">
  <thead>
    <tr>
      <th class="p-2 border">Pasto</th>
      <th class="p-2 border" *ngFor="let giorno of giorniSettimana">{{ giorno }}</th>
    </tr>
  </thead>
  <tbody *ngIf="dieta">
    <!-- Colazione -->
    <tr>
      <td class="p-2 border font-semibold">Colazione</td>
      <td class="p-2 border" *ngFor="let giorno of giorniSettimana; let i = index">
        <div class="card border p-1 rounded-lg flex flex-col h-full bg-white">
          <img [src]="getImage(dieta.colazione[i])"
               class="w-full h-20 object-cover mb-2" />
          <p class="text-center text-sm font-semibold">{{ getRicettaNome('colazione', i) }}</p>
        </div>
      </td>
    </tr>

    <!-- Pranzo -->
    <tr>
      <td class="p-2 border font-semibold">Pranzo</td>
      <td class="p-2 border" *ngFor="let giorno of giorniSettimana; let i = index">
        <div class="card border p-1 rounded-lg flex flex-col h-full bg-white">
          <img [src]="getImage(dieta.pranzo[i])"
               class="w-full h-20 object-cover mb-2" />
          <p class="text-center text-sm font-semibold">{{ getRicettaNome('pranzo', i) }}</p>
        </div>
      </td>
    </tr>

    <!-- Cena -->
    <tr>
      <td class="p-2 border font-semibold">Cena</td>
      <td class="p-2 border" *ngFor="let giorno of giorniSettimana; let i = index">
        <div class="card border p-1 rounded-lg flex flex-col h-full bg-white">
          <img [src]="getImage(dieta.cena[i])"
               class="w-full h-20 object-cover mb-2" />
          <p class="text-center text-sm font-semibold">{{ getRicettaNome('cena', i) }}</p>
        </div>
      </td>
    </tr>

    <!-- Spuntini -->
    <tr>
      <td class="p-2 border font-semibold">Spuntini</td>
      <td class="p-2 border" *ngFor="let giorno of giorniSettimana; let i = index">
        <div class="card border p-1 rounded-lg flex flex-col h-full bg-white">
          <img [src]="getImage(dieta.spuntini[i])"
               class="w-full h-20 object-cover mb-2" />
          <p class="text-center text-sm font-semibold">{{ getRicettaNome('spuntini', i) }}</p>
        </div>
      </td>
    </tr>
  </tbody>
</table>
